import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-475673f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row",
  style: {"border-radius":"25px","top":"50px"}
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 0,
  class: "card-body-custom"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, " VIEW", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isLoading == false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Datatable, {
                  "table-header": _ctx.tableHeader,
                  "table-data": _ctx.riderList,
                  "enable-items-per-page-dropdown": true,
                  currentPage: _ctx.route.query.current_page,
                  rowsPerPage: _ctx.route.query.row_per_page
                }, {
                  "cell-no": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.no), 1)
                  ]),
                  "cell-users_id": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.users_id), 1)
                  ]),
                  "cell-users_name": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.users_name), 1)
                  ]),
                  "cell-create_at": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.moment(item.create_at).format("YYYY-MM-DD HH:mm น.")), 1)
                  ]),
                  "cell-users_balance": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.users_balance), 1)
                  ]),
                  "cell-users_district": _withCtx(({ row: item }) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.users_district, (district, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: `district-${index}`
                      }, _toDisplayString(district.district_name_th), 1))
                    }), 128))
                  ]),
                  "cell-users_email": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.users_email), 1)
                  ]),
                  "cell-users_phone": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.users_phone), 1)
                  ]),
                  "cell-users_status": _withCtx(({ row: item }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass([
                    item.users_status == 1
                      ? 'badge_status--active'
                      : item.users_status == 2
                      ? 'badge_status--pending'
                      : 'badge_status--inactive',
                  ])
                    }, _toDisplayString(item.users_status == 1
                      ? "ACTIVE"
                      : item.users_status == 2
                      ? "PENDING"
                      : item.users_status == 3
                      ? "INACTIVE"
                      : "OTHER"), 3)
                  ]),
                  "cell-actions": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, [
                      _createVNode(_component_router_link, {
                        to: `/management/monitor-rider/${item.id}`,
                        class: "btn btn-info",
                        style: {"padding":"2px 10px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4,
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]),
                  _: 1
                }, 8, ["table-header", "table-data", "currentPage", "rowsPerPage"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}